import {get} from 'svelte/store';
import lang from './HomePage.lang';
import {PATHS} from '@/const';
import {fixLink$} from '@/store';
import {LINKS} from '@/const/link';

const fixLink = get(fixLink$);

export const TabOptions = [
  {label: 'BTC', value: 'BTC'},
  {label: 'PT', value: 'PT'},
];

export const CycleOptions = [
  {label: '1D', value: '1D', resolution: 60},
  {label: '1W', value: '1W', resolution: 360},
  {label: '1M', value: '1M', resolution: 1440},
  {label: '3M', value: '3M', resolution: 4320},
];

/**
 * title: 主标题
 * subTitle: 副标题，包含奖励数量等
 * startTime、endTime: 活动开始结束时间，UTC时间
 * link: 活动链接
 * linkIcon: 跳转箭头的图标，默认蓝色图标，主题色图标与UI协调
 * bannerStyle: banner图片样式微调，与UI协调
 * titleStyle: title样式微调，与UI协调
 * subTitleStyle: subTitle样式微调，与UI协调
 * */
export const Competitions = [
  // 圣诞节活动
  {
    title: lang.NewYearActivityTitle,
    subTitle: lang.ActivitySubTitle,
    startTime: '2024-12-18T10:00:00Z',
    endTime: '2025-01-06T10:00:00Z',
    link: fixLink(PATHS.SSR_ACTIVITY_NEWYEAR.pathname),
    linkIcon: 'https://img.phemex.com/v1/8e385bf0-86da-4911-9721-f59ad673f036/homepage-subtract.png',
    bannerImage: 'https://img.phemex.com/v1/987a451d-84d3-4797-8b6c-1d536bb12fdd/banner-3.png',
    bannerStyle: 'height: 100%; transform: translate(500px)',
  },
  // 交易活动引导
  {
    title: lang.PhemexTradingCompetition,
    subTitle: lang.ActivitySubTitleByShare,
    startTime: '2024-01-06T10:00:00Z',
    endTime: '2025-01-20T10:00:00Z',
    link: fixLink(PATHS.SSR_ACTIVITY_TRADING_COMPETITION_151.pathname),
    bannerImage: 'https://img.phemex.com/v1/4b73b586-95ec-4067-abf7-cc8158363d82/banner-home-2-5x.png',
    bannerStyle: 'height: 100%; transform: translate(500px)',
    titleStyle: 'background: linear-gradient(270.03deg, #39DEFF 0%, #FFF165 66%, #A1F9FA 100%);background-size: 200% auto; background-clip: text;-webkit-background-clip: text;',
    subTitleStyle: 'color: #fff',
  },
  // Big Lucky season 抽奖活动
  // {
  //   title: lang.BigLuckySeason,
  //   subTitle: lang.ActivitySubTitleWithBigLuckySeason,
  //   startTime: '2025-01-24T10:00:00Z',
  //   endTime: '2025-02-06T10:00:00Z',
  //   link: PATHS.SSR_LOTTERY_BIGLUCKY.pathname,
  //   bannerImage: 'https://img.phemex.com/v1/f3d43b3a-f19f-46fe-8697-2154ccd763d8/web-banner-0125-2x.png',
  //   bannerStyle: 'height: 100%; max-height: 488px; transform: translate(340px)',
  //   titleStyle: 'background: linear-gradient(270.03deg, #4A7CFF 0%, #36F0CF 66%, #4A7CFF 100%);background-size: 200% auto; background-clip: text;-webkit-background-clip: text;',
  //   subTitleStyle: 'color: #fff',
  // },
  // February 25 Trading Competition
  {
    title: lang.PhemexFeb25thTradingCompetition,
    subTitle: lang.ActivitySubTitleByFeb25thPNL,
    startTime: '2025-02-09T10:00:00Z',
    endTime: '2025-02-26T10:00:00Z',
    link: fixLink(PATHS.SSR_ACTIVITY_TRADING_COMPETITION_173.pathname),
    linkIcon: 'https://img.phemex.com/v1/4bbd0a60-dad2-499b-884b-a9702d376bb9/frame-1000005582.svg',
    bannerImage: 'https://img.phemex.com/v1/21e5724a-a411-498a-be60-12bd72f35926/1920-x440-2.png',
    bannerStyle: 'height: 100%; transform: translate(500px)',
    titleStyle: 'background: linear-gradient(270.03deg, #00D4FF 0%, #B2FF00 66%, #00D4FF 100%);background-size: 200% auto; background-clip: text;-webkit-background-clip: text;',
    subTitleStyle: 'color: #fff; text-shadow: 0 2px 8px rgba(0,0,0,0.6);',
  },
  {
    title: lang.PhemexMarTradingCarnival,
    subTitle: lang.PhemexMarTradingCarnivalSubTitle,
    startTime: '2025-03-07T10:00:00Z',
    endTime: '2025-03-23T10:00:00Z',
    link: fixLink(PATHS.SSR_MR_TRADING_CARNIVAL.pathname),
    linkIcon: 'https://img.phemex.com/v1/4bbd0a60-dad2-499b-884b-a9702d376bb9/frame-1000005582.svg',
    bannerImage: 'https://img.phemex.com/v1/05d1a026-7bd1-4d68-88b6-db807a4a124a/1920-x440.png',
    bannerStyle: 'height: 90%; transform: translate(450px)',
    titleStyle: 'background: linear-gradient(270.03deg, #00D4FF 0%, #B2FF00 66%, #00D4FF 100%);background-size: 200% auto; background-clip: text;-webkit-background-clip: text;',
    subTitleStyle: 'color: #fff; text-shadow: 0 2px 8px rgba(0,0,0,0.6);',
  },
];

export const TradeEarnEnums = [
  {
    key: 'FT',
    title: lang.FuturesTrading,
    subTitle: lang.TradeEarnFTSubTitle,
    img: 'https://img.phemex.com/v1/979b66b5-355c-40cc-ae28-d2b241364963/frame-1000005857.png',
    firstText: lang.TradingVol24H,
    firstVal: '0.00',
    secondText: lang.FuturesPairs,
    secondVal: '0',
    pairsNum: '0',
    linkTxt: lang.TradingNow,
    linkUrl: fixLink(LINKS.PHEMEX_CONTRACT_TRADE + '/BTC-USDT'),
  },
  {
    key: 'SM',
    title: lang.TradeEarnSM_New,
    subTitle: lang.TradeEarnSMSubTitle,
    img: 'https://img.phemex.com/v1/b236072c-ab3c-4d39-a217-36fd4dde7c79/frame-1000005815.png',
    firstText: lang.TradingVol24H,
    firstVal: '0.00',
    secondText: lang.SpotPairs,
    secondVal: '0',
    pairsNum: '0',
    linkTxt: lang.TradingNow,
    linkUrl: fixLink(LINKS.SPOT_TRADE + '/BTC-USDT'),
  },
  {
    key: 'TB',
    title: lang.TradingBots,
    subTitle: lang.TradeEarnTBSubTitle,
    img: 'https://img.phemex.com/v1/ef1bf55a-9595-4852-a91e-984801ad6712/frame-1000005846.png',
    firstText: lang.BotTradingEarnings,
    firstVal: '0.00',
    secondText: lang.BotsWorldwide,
    secondVal: '0',
    linkTxt: lang.CreateBot,
    linkUrl: fixLink(PATHS.STRATEGY_SQUARE.pathname),
  },
  {
    key: 'PLP',
    title: lang.TradeEarnPLP,
    subTitle: lang.TradeEarnPLPSubTitle,
    img: 'https://img.phemex.com/v1/b7c87999-d022-4aeb-80b2-df78a28ccb7f/frame-1000005854.png',
    firstText: lang.SupplyAPR,
    firstVal: '0.00',
    secondText: lang.TotalAvailable,
    secondVal: '0',
    linkTxt: lang.OneClickLending,
    linkUrl: fixLink(PATHS.WEB3_LENDING_MARKET.pathname),
  },
];

export const MARKET_TAB_TYPE = {
  SPOT: 'SPOT',
  CONTRACT: 'CONTRACT',
  NEW_LISTING: 'NEW_LISTING',
  GAINER: 'GAINER',
  MEMEX: 'MEMEX',
};

export const FaqOptions = [
  {
    title: lang.FAQTitle_1,
    content: lang.FAQAnswer_1,
    linkTxt: lang.Bitcoin,
    markName: 'Bitcoin',
    mark: {
      Bitcoin: 'Bitcoin',
    },
    linkUrl: fixLink('/markets/price/bitcoin-btc'),
  },
  {
    title: lang.FAQTitle_2,
    content: [
      lang.FAQAnswer_2_title,
      [
        {
          content: lang.FAQAnswer_2_1,
          linkTxt: lang.SpotTrading,
          markName: 'SpotTrading',
          mark: {
            SpotTrading: 'Spot Trading',
          },
          linkUrl: fixLink(LINKS.SPOT_TRADE + '/BTC-USDT'),
        },
        {
          content: lang.FAQAnswer_2_2,
          linkTxt: lang.FuturesTrading,
          markName: 'FuturesTrading',
          mark: {
            FutruesTrading: 'Futrues Trading',
          },
          linkUrl: fixLink(LINKS.PHEMEX_CONTRACT_TRADE + '/BTC-USDT'),
        },
        {
          content: lang.FAQAnswer_2_3,
          linkTxt: lang.CopyTrading,
          markName: 'CopyTrading',
          mark: {
            CopyTrading: 'Copy Trading',
          },
          linkUrl: fixLink(PATHS.COPY_TRADING_LIST.pathname),
        },
        {
          content: lang.FAQAnswer_2_4,
          linkTxt: lang.TradingBots,
          markName: 'TradingBots',
          mark: {
            TradingBots: 'Trading Bots',
          },
          linkUrl: fixLink(PATHS.STRATEGY_SQUARE.pathname + '?type=CONTRACT_GRID'),
        },
        {
          content: lang.FAQAnswer_2_5,
          linkTxt: lang.CryptoPurchase,
          markName: 'CryptoPurchase',
          mark: {
            CryptoPurchase: 'Crypto Purchase',
          },
          linkUrl: fixLink(PATHS.FIAT_BUY_CRYPTO_PLACE_ORDER.pathname),
        },
      ],
      lang.FAQAnswer_2_summarize,
    ],
  },
  {
    title: lang.FAQTitle_3,
    content: [
      [
        {
          content: lang.FAQAnswer_3_1,
          linkTxt: lang.SignUp,
          markName: 'SignUp',
          mark: {
            SignUp: 'Sign Up',
          },
          linkUrl: fixLink(PATHS.REGISTER.pathname),
        },
        lang.FAQAnswer_3_2,
        lang.FAQAnswer_3_3,
        lang.FAQAnswer_3_4,
      ],
    ],
  },
  {
    title: lang.FAQTitle_4,
    content: lang.FAQAnswer_4,
    linkTxt: [lang.BitcoinPrice, lang.EthereumPrice],
    markName: ['BitcoinPrice', 'EthereumPrice'],
    mark: {
      Bitcoinprice: 'Bitcoin price',
      Ethereumprice: 'Ethereum price',
    },
    linkUrl: [fixLink('/markets/price/bitcoin-btc'), fixLink('/markets/price/ethereum-eth')],
  },
  {
    title: lang.FAQTitle_5,
    content: [
      [
        {
          content: lang.FAQAnswer_5_1,
          linkTxt: lang.SignUp,
          markName: 'SignUp',
          mark: {
            SignUp: 'Sign Up',
          },
          linkUrl: fixLink(PATHS.REGISTER.pathname),
        },
        lang.FAQAnswer_5_2,
        lang.FAQAnswer_5_3,
        lang.FAQAnswer_5_4,
      ],
    ],
  },
  {
    title: lang.FAQTitle_6,
    content: [
      [
        {
          content: lang.FAQAnswer_6_1,
          linkTxt: lang.SpotTrading,
          markName: 'SpotTrading',
          mark: {
            SpotTrading: 'Spot Trading',
          },
          linkUrl: fixLink(LINKS.SPOT_TRADE + '/BTC-USDT'),
        },
        {
          content: lang.FAQAnswer_6_2,
          linkTxt: lang.FuturesTrading,
          markName: 'FuturesTrading',
          mark: {
            FuturesTrading: 'Futures Trading',
          },
          linkUrl: fixLink(LINKS.PHEMEX_CONTRACT_TRADE + '/BTC-USDT'),
        },
      ],
    ],
  },
  {
    title: lang.FAQTitle_7,
    content: lang.FAQAnswer_7,
  },
];
